module.exports = __webpack_public_path__ + "img/ricardo_green.b011e9da.jpg";